
import { mapGetters, mapMutations } from "vuex";
import router from "@/router";
import swal from "sweetalert";
import { FamilyPlanInviteViewModel } from "@/interfaces/FamilyPlanInviteViewModel";
import { FamilyUserStatusIDEnum } from "@/interfaces/FamilyUserStatusIDEnum";

export default {
  data() {
    return {
      familyPlanDetails: {} as FamilyPlanInviteViewModel,
      isSubmitting: false,
    };
  },
  async mounted() {
    await this.fetchDetails();
  },

  computed: {
    ...mapGetters({
      Content: "getContent",
      Affiliate: "getAffiliate",
    }),
  },

  methods: {
    ...mapMutations({
      SetLoading: "setLoading",
    }),
    async fetchDetails() {
      try {
        const response = await this.$store.dispatch("GetPendingFamilyPlanRequest");

        if (!response || !response.success) {
          return;
        }

        if (response && response.data) {
          this.familyPlanDetails = response.data;
        } else {
          swal({
            title: "Invalid Invitation",
            text: "This invite is no longer valid.",
            icon: "warning",
            buttons: {
              confirm: {
                text: "Okay",
                value: true,
                visible: true,
                className: "",
                closeModal: true,
              },
            },
          }).then(() => {
            router.push("/patientportal");
          });
        }
      } catch (error) {
        swal("Error", "Error loading family plan invite. Please try again.", "error");
      }
    },

    async confirmAction(message: string): Promise<boolean> {
      return swal({
        title: "Are you sure?",
        text: message,
        icon: "warning",
        buttons: ["Cancel", "Yes"],
        dangerMode: true,
      });
    },

    async handleResponse(accepted: boolean) {
      if (this.isSubmitting) return;
      this.isSubmitting = true;

      const action = accepted ? "ACCEPT" : "DENY";
      const name = `${this.familyPlanDetails.mainUserFirstName} ${this.familyPlanDetails.mainUserLastName}`;
      const confirmed = await this.confirmAction(`Are you sure that you want to ${action} the family plan invitation from ${name}?`);

      if (!confirmed) {
        this.isSubmitting = false;
        return;
      }

      try {
        this.SetLoading(true);

        // Update the enum value based off of user's response
        this.familyPlanDetails.familyUserStatusID = accepted ? FamilyUserStatusIDEnum.Accepted : FamilyUserStatusIDEnum.Denied;

        const response = await this.$store.dispatch("FamilyPlanInvitationConfirmation", this.familyPlanDetails);

        if (response.data && response.data.success) {
          swal("Success", `You have ${accepted ? "accepted" : "denied"} the invitation.`, "success");
          router.push("/patientportal");
        } else {
          swal("Error", "An error occurred. Please try again.", "error");
          this.isSubmitting = false;
        }
      } catch (error) {
        swal("Error", "Unable to send your response. Please try again.", "error");
      } finally {
        this.SetLoading(false);
        this.isSubmitting = false;
      }
    },
  },
};
